import { NgModule } from '@angular/core';
import { BaseUpgradeComponent } from './base-upgrade.component';

const COMPONENTS = [BaseUpgradeComponent];

@NgModule({
  declarations: COMPONENTS,
  exports: COMPONENTS,
})
export class BaseUpgradeModule {}
